// Component Name:  Customers component
// Author: Bharath
// Platform: Web
// OS: Windows
// IDE: Visual Studio Code
// Reference: AddLocation
// Date:
// Description: This component is to Add, view and delete user.
// Dependencies: React,  Redux , API layer to fetch a, add and delete user
// Interfaces: Accepts props toast messages
// Maintenance History:  1.0 - First Version

// Edited by Lavanya S
// [25-04-2025] Integrated toast messages,API and enabled add, view and delete user.
// [20-05-2025] Integrated actionable pop to delete the user(confirm before deletion)

import React, { Component } from "react";
import { Container, Card, CardBody, Row, Col, Table, UncontrolledTooltip, Spinner } from "reactstrap";
import ReactModal from "react-modal";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { getTransactionByUserId, getUser } from "../../api/userAPI";
import { connect } from "react-redux";
import { successToast, warningPopUp } from "../../store/dbFilter/actions";
import { MONTHS } from "../Utility/Constants";
import MiniWidgets from "../Dashboard/MiniWidgets";
import AddUser from "./AddUser";
import RFIDBlackListMgmt from "./RFIDBlackListMgmt";
import { addUserIds, userSelected } from "../../store/users/actions";
import LKEditImg from "../../assets/images/LK_Icons/LK_Modify-Edit.svg";
import LKDeleteImg from "../../assets/images/LK_Icons/LK_Delete.svg";
import LKSavingImg from "../../assets/images/LK_Icons/LK__Savings.svg";
import LKTransactionImg from "../../assets/images/LK_Icons/LK__Transaction History 1.svg";
import LKAddUserImg from "../../assets/images/LK_Icons/LK_White_Add User.svg";
import LKAddHoverUserImg from "../../assets/images/LK_Icons/LK_Add User.svg";
import LKRemoveUserImg from "../../assets/images/LK_Icons/LK_Remove User.svg";

import { ActiveBtn } from "../Utility/Button";

class Customers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbItems: [
        { title: "Charger Management System", link: "#" },
        { title: "Users", link: "#" },
      ],
      isAlertOpen: false,
      modal_static: false,
      isRFIDModalOpen: false,
      isUserUpdated: false,
      isLoading: false,
      expandedRow: null,
      customerData: {
        name: "",
        phoneNumber: "",
        email: "",
        balance: 0,
        creditLimit: 0,
        status: "Accepted",
      },
      blackListedData: [],
      totalBalance: 0,
      totalTransactions: 0,
      rfid: [],
      paymentType: "Prepaid",
      data: [],
      userDataIds: [],
      AllUserData: [],
    };
  }

  componentDidMount() {
    ReactModal.setAppElement("#root");
    this.updateViewUser();
  }
  componentDidUpdate(prevProps, prevState) {
    console.log("this.state.userDataIds: ", this.state.userDataIds);

    if (JSON.stringify(this.props.userIds) === JSON.stringify(prevProps.userIds)) return;
    else {
      this.updateViewUser();
      // this.props.addUserIds(this.state.userDataIds);
    }
  }
  /**
   * Makes a call to get the User
   * @param {string} id - to get the User valid "id"
   * @returns - returns User data, fetch all the user data and store it in the data state
   */
  handleGetUser = async (id) => {
    this.setState({ isLoading: true });
    try {
      const response = await getUser(id);
      console.log("response : ", response);
      const { message, data } = response;
      this.setState({ isLoading: false });
      return data;
    } catch (err) {
      console.log("Error getting the User", err?.msg || err);
    }
  };

  // this function is used to fetch all the available user under the host and display it
  // format the each user to display in the row
  updateViewUser = async () => {
    const data = await this.handleGetUser(this.props?.email);

    this.setState({ AllUserData: data });
    let ids = [];
    let userBalance = 0;
    let RFIDBlackList = [];
    const userdata = data?.map((item) => {
      const { _id, email, name, phoneNumber, rfids, registeredDate, balance, status } = item;
      const date = new Date(registeredDate);
      const userDate = `${date.getDate()} ${MONTHS[date.getMonth()]} ${date.getFullYear()}`;
      ids.push(phoneNumber);
      userBalance += balance;
      status === "Blocked" && RFIDBlackList.push(item);
      return {
        user: (
          <Link
            to="/cms-user-details"
            onClick={() => {
              this.props.userSelected(item);
            }}
          >
            {name}
          </Link>
        ),
        id: _id,
        email: email,
        phone: phoneNumber,
        rfid: rfids?.length === 0 ? "NA" : phoneNumber,
        date: userDate,
        balance: balance,
        rfidDetails: rfids,
      };
    });
    this.setState({ data: userdata, userDataIds: ids, totalBalance: userBalance, blackListedData: RFIDBlackList }, () => {
      this.props.addUserIds(ids); //  only called once after state update
    });
    this.loadTransactionsByUserId(ids);
  };

  // Onclick edit user fetch and pre-populate the model with the user details
  handleEditUser = async (id) => {
    // const data = await this.handleGetUser(this.props?.email);
    const data = this.state?.AllUserData?.filter((item) => item?.phoneNumber === id);
    const { email, name, phoneNumber, rfids, balance, creditLimit, status } = data[0];
    this.setState({
      customerData: {
        name: name,
        phoneNumber: phoneNumber,
        email: email,
        balance: balance,
        creditLimit: creditLimit,
        status: status,
      },
      paymentType: rfids?.length === 0 ? "Prepaid" : "Postpaid",
      rfid: rfids,
    });
  };

  /**
   * Makes a call to delete the User
   * @param {string} id - to delete the User valid "id"
   * @returns - returns User data
   */
  handleDeleteUser = async (id) => {
    this.props.warningPopUp({
      id: id,
      title: "Warning",
      popUpType: "DELETE_USER",
      message: "Are you sure you want to delete?",
    });
  };

  // reset all the data before closing the modal
  resetUserData = () => {
    this.setState({
      customerData: {
        name: "",
        phoneNumber: "",
        email: "",
        balance: 0,
        creditLimit: 0,
        status: "Accepted",
      },
      rfid: [],
      paymentType: "Prepaid",
    });
  };

  // to find the total transaction
  loadTransactionsByUserId = async (data) => {
    let transactions = 0;
    await Promise.all(
      data.map(async (id) => {
        try {
          const response = await getTransactionByUserId(id);
          const { message, data } = response;

          transactions += data?.length;
        } catch (err) {
          console.log("Error loading transactions for ID", err);
        }
      })
    );
    // console.log("transactions: ", transactions);
    this.setState({ totalTransactions: transactions });
  };
  toggleExpandRow = (key) => {
    this.setState((prevState) => ({
      expandedRow: prevState.expandedRow === key ? null : key,
    }));
  };
  render() {
    const reports = [
      {
        // icon: "ri-arrow-left-right-line",
        image: LKTransactionImg,
        title: "Total Transaction",
        value: `${this.state.totalTransactions}`,
      },
      {
        // icon: "ri-wallet-line",
        image: LKSavingImg,
        title: "Balance",
        value: `\u20B9 ${this.state.totalBalance}`,
      },
      {
        image: LKRemoveUserImg,
        title: "RFID Blacklist",
        value: `${this.state?.blackListedData?.length}`,
        WidgetClick: () => {
          this.setState({ isRFIDModalOpen: true });
          console.log("clicked");
        },
      },
    ];
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="Customers" breadcrumbItems={this.state.breadcrumbItems} />
            {/* Add user/edit user */}
            {this.state.modal_static && (
              <AddUser
                userData={{ ...this.state.customerData, rfids: this.state.rfid, payType: this.state.paymentType }}
                isModalOpen={this.state.modal_static}
                closeModal={(isUpdated) => {
                  this.setState({ modal_static: false });
                  isUpdated && this.updateViewUser();
                }}
              />
            )}
            <div>
              <RFIDBlackListMgmt
                data={this.state?.blackListedData}
                isModalOpen={this.state.isRFIDModalOpen}
                closeModal={() => {
                  this.setState({ isRFIDModalOpen: false });
                }}
              />
            </div>

            <Row>
              <MiniWidgets reports={reports} />
            </Row>
            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <div>
                      {/* <Link
                        to="#"
                        onClick={() => {
                          this.resetUserData();
                          this.setState({
                            modal_static: true,
                            isAlertOpen: false,
                          });
                        }}
                        className="btn btn-success mb-2"
                      >
                        <i className="mdi mdi-plus mr-2"></i> Add Customer
                      </Link> */}
                      <ActiveBtn
                        name={"Add Customer"}
                        handleClick={() => {
                          this.resetUserData();
                          this.setState({
                            modal_static: true,
                            isAlertOpen: false,
                          });
                        }}
                        image={LKAddUserImg}
                        hoverImg={LKAddHoverUserImg}
                      />
                    </div>
                    {/* user detatils are displayed here */}
                    <div className="table-responsive mt-3">
                      <Table
                        className="table-centered datatable dt-responsive nowrap "
                        style={{
                          borderCollapse: "collapse",
                          borderSpacing: 0,
                          width: "100%",
                        }}
                      >
                        <thead className="thead-light">
                          <tr>
                            {/* <th style={{ width: "20px" }}>
                              <div className="custom-control custom-checkbox">
                                <Input type="checkbox" className="custom-control-input" id="customercheck" />
                                <Label className="custom-control-label" htmlFor="customercheck">
                                  &nbsp;
                                </Label>
                              </div>
                            </th> */}
                            <th>User</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Balance</th>
                            <th>Rfid</th>
                            <th>Joining Date</th>
                            <th style={{ width: "120px" }}>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this?.state?.isLoading ? (
                            <tr>
                              <td colSpan={7} style={{ height: "250px", textAlign: "center" }}>
                                <Spinner />
                              </td>
                            </tr>
                          ) : this.state.data?.length === 0 ? (
                            <tr>
                              <td colSpan={7} style={{ textAlign: "center" }}>
                                <h4> There are no users</h4>
                              </td>
                            </tr>
                          ) : (
                            this.state.data?.map((customerData, key) => (
                              <React.Fragment  key={key}>
                                <tr>
                                  {/* <td>
                                  <div className="custom-control custom-checkbox">
                                    <Input type="checkbox" className="custom-control-input" id={"customercheck" + key} />
                                    <Label className="custom-control-label" htmlFor={"customercheck" + key}>
                                      &nbsp;
                                    </Label>
                                  </div>
                                </td> */}

                                  <td>{customerData.user}</td>
                                  <td>{customerData.email}</td>
                                  <td>{customerData.phone}</td>
                                  <td>{customerData.balance}</td>
                                  {customerData.rfid === "NA" ? (
                                    <td>{customerData.rfid}</td>
                                  ) : (
                                    <td
                                      style={{
                                        cursor: "pointer",
                                        color: "#005C8E",
                                        textDecoration: "underline",
                                      }}
                                      onClick={() => this.toggleExpandRow(key)}
                                    >
                                      {"View RFID"}
                                    </td>
                                  )}
                                  <td>{customerData.date}</td>
                                  <td>
                                    <Link
                                      to="#"
                                      className="mr-3 text-primary"
                                      id={"edit" + key}
                                      onClick={async () => {
                                        await this.handleEditUser(customerData.phone);
                                        this.setState({
                                          modal_static: true,
                                          isAlertOpen: false,
                                        });
                                      }}
                                    >
                                      {/* <i className="mdi mdi-pencil font-size-18"></i> */}
                                      <img src={LKEditImg} alt={"Edit img"} style={{ width: "20px", height: "20px" }} />
                                    </Link>
                                    <UncontrolledTooltip target={"edit" + key} placement="top">
                                      Edit
                                    </UncontrolledTooltip>
                                    <Link to="#" className="text-danger" id={"delete" + key} onClick={() => this.handleDeleteUser(customerData?.phone)}>
                                      {/* <i className="mdi mdi-trash-can font-size-18"></i> */}
                                      <img src={LKDeleteImg} alt={"delete img"} style={{ width: "25px", height: "25px" }} />
                                    </Link>
                                    <UncontrolledTooltip target={"delete" + key} placement="top">
                                      Delete
                                    </UncontrolledTooltip>
                                  </td>
                                </tr>
                                {this.state.expandedRow === key && (
                                  <tr>
                                    <td colSpan="7">
                                      <div
                                        style={{
                                          padding: "10px",
                                          backgroundColor: "#f9f9f9",
                                          maxHeight: "350px",
                                          overflowY: "auto",
                                          scrollbarWidth: "thin",
                                          scrollbarColor: "rgba(0,92,142,0.6) #f0f0f0",
                                        }}
                                      >
                                        <strong>RFID Details for {customerData?.user}</strong>
                                        <div className="my-1">
                                          {(Array.isArray(customerData.rfidDetails) ? customerData.rfidDetails : [customerData.rfidDetails]).map((rfidItem, index) => (
                                            <div key={index} className="mb-1 mx-2">
                                              {index + 1}. <span>{rfidItem}</span>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            ))
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  userIds: state?.UserManagement?.userIds,
  email: state?.Login?.user?.email,
});
const mapDispatchToProps = (dispatch) => ({
  successToast: (payload) => dispatch(successToast(payload)),
  userSelected: (payload) => dispatch(userSelected(payload)),
  warningPopUp: (payload) => dispatch(warningPopUp(payload)),
  addUserIds: (payload) => dispatch(addUserIds(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Customers);
